import React from 'react';

interface Props {
  onError?: (error: any, errorInfo: any) => void;
  // silent?: boolean;
  children?: React.ReactNode;
}

// export const ErrorBoundary: React.FC<Props> = ({children, onError, silent}) => {
//   try {
//     return React.Fragment({children});
//   } catch {
//     silent || console.error('ErrorBoundary did catch error', children);
//     onError && onError();
//   } finally {
//     return null;
//   }
// };

export class ErrorBoundary extends React.Component<Props, {hasError: boolean}> {
  constructor(props: Props) {
    super(props);
    this.state = {hasError: false};
  }

  static getDerivedStateFromError() {
    return {hasError: true};
  }

  componentDidCatch(error: any, errorInfo: any) {
    this.props.onError && this.props.onError(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return null;
    }

    return this.props.children;
  }
}
